export default __webpack_public_path__ + "static/media/285.e77e41df.jpg";